import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Header from "../../../layout/mypage/Header";
import Footer from "../../../layout/mypage/Footer";
import {
  validateEmailAddress,
  validateHalfAlphaNum,
} from "../../../../utils/validate";
import { MSG } from "../../../../utils/adminMessages";
import { postSendMail } from "../../../../services/apiMyPageLogin";
import MypageTextField from "../../../ui/MypageTextField";
import ScreenColorSetting, {
  getDefaultScreenColor,
} from "../../../layout/mypage/ScreenColorSetting";
import { MYPAGE_HTML_TITLE } from "../../../../utils/config";

// パスワードをお忘れの方画面
const PasswordForget = () => {
  // メール送信完了フラグ
  const [compFlg, setCompFlg] = useState(false);

  // エラーメッセージ
  const [errorMsg, setErrorMsg] = useState("");
  // 入力メールアドレス
  const [mailAddress, setMailAddress] = useState("");
  // 画面背景色 color-standard or color-black or color-blue
  const [screenColor, setScreenColor] = useState(getDefaultScreenColor());
  // 入力チェック用
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  // 送信するボタン
  const onSubmit = async (data) => {
    const result = await postSendMail(data);
    if (!result) setErrorMsg(MSG.LOGIN_FAIL);
    setMailAddress(data["mail_address"]);
    setCompFlg(true);
    scrollTop();
  };

  // スクロールを一番上に移動
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  useEffect(() => {
    (function () {
      scrollTop();
      document.title = `パスワードをお忘れの方 | ${MYPAGE_HTML_TITLE}`;
    })();
  });

  return (
    <>
      <ScreenColorSetting screenColor={screenColor} />
      <div className="mypage-site">
        <Header
          setScreenColor={setScreenColor}
          screenColor={screenColor}
          isLogin={false}
        />
        {compFlg ? (
          <main className="l-main">
            <div className="container">
              <div className="col-lg-10 offset-lg-1">
                <div className="p-login-con">
                  <h1 className="p-heading01">パスワードをお忘れの方</h1>
                  <div className="p-login-txtbox">
                    <p className="mb-5">
                      {mailAddress}へパスワード再設定メールを送信しました。
                    </p>
                    <p>※再設定は完了していませんので、ご注意ください。</p>
                    <p className="mb-5">
                      メールに記載のURLをクリックしていただき、パスワードの再設定を完了してください。
                    </p>
                    <p>
                      メールが届かない場合は、学生番号またはメールアドレスが間違っている可能性があります。
                    </p>
                    <p className="mb-5">
                      ご確認頂き、再度手続きを行ってください。
                    </p>
                  </div>
                  <div className="p-login-form__btnbox">
                    <Link className="p-login-form__link" to="/mypage/login">
                      ログイン画面へ戻る
                    </Link>
                  </div>
                </div>
                <div className="p-login-return">
                  <a
                    className="p-login-return__link"
                    href={process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN + "/"}
                  >
                    <img
                      className="p-login-return__img"
                      src="/common/assets/images/logo02.svg"
                      alt=""
                    />
                    <span className="p-login-return__txt">
                      シブカツトップページに戻る
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </main>
        ) : (
          <main className="l-main">
            <div className="container">
              <div className="col-lg-10 offset-lg-1">
                <div className="p-login-con">
                  <h1 className="p-heading01">パスワードをお忘れの方</h1>
                  <div className="p-login-txtbox">
                    <p className="mb-5">
                      「シブカツ」にご登録いただいたメールアドレスを入力し、送信するボタンを押してください。
                    </p>
                    <p>パスワード再設定用URLが記載されたメールを送信します。</p>
                    <p className="mb-5">
                      メールに記載されたURLにアクセスいただき、新しいパスワードをご入力の上、再設定をお願い致します。
                    </p>
                    <p>
                      ※学生番号もしくはメールアドレスがわからない方はお問い合わせください。
                    </p>
                  </div>
                  <div className="p-login-con__bottom mb-5">
                    <ul className="p-login-con__list">
                      <li className="p-login-con__item">
                        <Link
                          className="p-login-con__link"
                          to="/mypage/inquiry"
                          state={{
                            prevlink: "/mypage/password",
                            isMypage: true,
                          }}
                        >
                          お問い合わせ
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <form
                    action=""
                    className="p-login-form"
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <div className="p-login-con__form">
                      <MypageTextField
                        name="login_id"
                        label="学生番号"
                        maxLength={8}
                        register={register}
                        validation={{ ...validateHalfAlphaNum() }}
                        errors={errors}
                        watch={watch}
                        required={true}
                        placeholder="学生番号を入力してください"
                      />
                      <MypageTextField
                        name="mail_address"
                        label="メールアドレス"
                        maxLength={100}
                        register={register}
                        validation={{ ...validateEmailAddress() }}
                        errors={errors}
                        watch={watch}
                        required={true}
                        placeholder="メールアドレスを入力してください"
                      />
                      <div className="p-login-form__btnbox">
                        <div className="p-login-form__returnbtn">
                          <Link to="/mypage/login">
                            <input
                              className="p-login-form__link"
                              type="button"
                              value="戻る"
                            />
                          </Link>
                        </div>
                        <div className="p-login-form__send">
                          <input
                            className="p-login-form__link"
                            type="submit"
                            value="送信する"
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="p-login-return">
                  <a
                    className="p-login-return__link"
                    href={process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN + "/"}
                  >
                    <img
                      className="p-login-return__img"
                      src="/common/assets/images/logo02.svg"
                      alt=""
                    />
                    <span className="p-login-return__txt">
                      シブカツトップページに戻る
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </main>
        )}
        <Footer is_login={true} />
      </div>
    </>
  );
};
export default PasswordForget;
